import axios from './axiosService';
import {
  ADD_USERS_WALLET,
  // ADD_USERS_WALLET,
  BOOST,
  BOOSTERS,
  CLAIM,
  CLAIM_REF_BONUS,
  COMPLET_TASK,
  CREATE_GAME,
  CREATE_GROUP,
  DAILYREWARD,
  GAME_DEPOSIT_ADDRESS,
  GAME_WITHDRAWAL_ENPOINT,
  GET_ACTIVE_GAMES,
  GET_GAME,
  GET_GAME_LEADERBOARD,
  GET_REF_LEADERBOARD,
  GET_GROUPS,
  GET_TOKEN_BALANCES,
  GET_TRANSACTION_DETAILS,
  GET_UPLINE_WALLET,
  GET_WALLET_HISTORY,
  INIT_TRANSACTION,
  JOIN_GAME,
  JOIN_GROUP,
  SUBMIT_SCORE,
  SYNC_ACCOUNT,
  TASK,
  TASKS,
  USER_BY_ID,
  ADD_TASK,
  USER_IN_CHANNEL,
  BUY_AIRTIME,
  GET_SERVICE_VARIATIONS,
  BUY_DATA,
  GET_ELECTRICITY_PROVIDERS,
  VERIFY_METER_NUMBER,
  VERIFY_SMART_CARD_NUMBER,
  BUY_POWER,
  GET_POWER_TOKEN,
  GET_TV_PROVIDERS,
  GET_TV_BOUQUETS,
  VERIFY_TV_SMART_CARD,
  PAY_TV_SUBSCRIPTION,
  GET_UTILITIES_TRANSACTION,
  GET_UTILITY_TRANSACTIONS,
  GET_UTILITY_TRANSACTION,
  GET_DOWNLINE_PURCHASES,
  GET_REFERRALS,
} from './endpoints';
import { getWalletsFromDb } from './db';

export const getUserByTelegramID = async (id) => {
  try {
    const result = await axios.get(USER_BY_ID(id));
    return result.data;
  } catch (error) {
    return null;
  }
};

export const createAccount = async (userData) => {
  const result = await axios.post(SYNC_ACCOUNT(), userData);
  return result.data.user;
};

export const claimToken = async (telegramId) => {
  const result = await axios.post(CLAIM(telegramId));
  return result.data;
};

export const claimReBonus = async (telegramId) => {
  const result = await axios.post(CLAIM_REF_BONUS(telegramId));
  return result.data;
};

export const getBoosters = async () => {
  const result = await axios.get(BOOSTERS());
  return result.data;
};

export const boost = async (input) => {
  const result = await axios.post(BOOST(), input);
  return result.data;
};

export const getTasks = async (userId) => {
  const result = await axios.get(TASKS(userId));
  return result.data;
};

export const getTask = async () => {
  const result = await axios.get(TASK());
  return result.data;
};

export const completeTask = async (userId, taskId, proof) => {
  const result = await axios.post(COMPLET_TASK(userId, taskId), { proof });
  return result.data;
};

export const fetchEthereumData = async () => {
  try {
    const response = await axios.get(
      'https://api.coingecko.com/api/v3/coins/ethereum'
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Ethereum data:', error);
    return null;
  }
};

export const initTransaction = async (transactionData) => {
  const result = await axios.post(INIT_TRANSACTION(), transactionData);
  return result.data;
};

export const getTransactionDetails = async (txid) => {
  const result = await axios.get(GET_TRANSACTION_DETAILS(txid));
  return result.data;
};

export const getWallets = async () => {
  return getWalletsFromDb();
};

export const getWalletHIstory = async (wallet) => {
  const result = await axios.get(GET_WALLET_HISTORY(wallet));
  return result.data;
};

export const getTokenBalances = async (wallet) => {
  const result = await axios.get(GET_TOKEN_BALANCES(wallet));
  return result.data;
};

export const collectGame = async () => {};

export const addUsersWallet = async (userid, address, label) => {
  const result = await axios.post(ADD_USERS_WALLET(userid), { address, label });
  return result.data;
};

export const createGroup = async (payload) => {
  const result = await axios.post(CREATE_GROUP(payload));
  return result.data;
};

export const joinGroup = async () => {
  const result = await axios.post(JOIN_GROUP());
  return result.data;
};

export const getGroups = async () => {
  const result = await axios.get(GET_GROUPS());
  return result.data;
};

export const createGame = async (payload) => {
  const result = await axios.post(CREATE_GAME(), payload);
  return result.data;
};

export const joinGame = async (payload) => {
  const result = await axios.post(JOIN_GAME(), payload);
  return result.data;
};

export const submitScore = async () => {
  const result = await axios.post(SUBMIT_SCORE());
  return result.data;
};

export const getDepositAddress = async () => {
  const result = await axios.get(GAME_DEPOSIT_ADDRESS());
  return result.data;
};

export const getGame = async (code) => {
  const result = await axios.get(GET_GAME(code));
  return result.data;
};

export const getActiveGames = async (code) => {
  const result = await axios.get(GET_ACTIVE_GAMES(code));
  return result.data;
};

export const claimDailyReward = async (telegramId) => {
  const result = await axios.post(DAILYREWARD(telegramId));
  return result.data;
};

export const getUplineWallets = async (userId) => {
  const result = await axios.get(GET_UPLINE_WALLET(userId));
  return result.data;
};

export const getGameLeaderboard = async () => {
  const result = await axios.get(GET_GAME_LEADERBOARD());
  return result.data;
};

export const submitGameWithdrawal = async (req) => {
  const result = await axios.post(GAME_WITHDRAWAL_ENPOINT(), req);
  return result.data;
};

export const getRefLeaderboard = async (type) => {
  const result = await axios.get(GET_REF_LEADERBOARD(type));
  return result.data;
};

export const addTasks = async (taskData) => {
  const result = await axios.post(ADD_TASK(), taskData);
  return result.data;
};

export const userInChannel = async (telegramID) => {
  const result = await axios.post(USER_IN_CHANNEL(telegramID));
  return result.data;
};

export const buyAirtime = async (payload) => {
  const result = await axios.post(BUY_AIRTIME(), payload);
  return result.data;
};

export const getServiceVariations = async (serviceId) => {
  const result = await axios.get(GET_SERVICE_VARIATIONS(serviceId));
  return result.data;
};

export const buyData = async (payload) => {
  const result = await axios.post(BUY_DATA(), payload);
  return result.data;
};

export const getElectricityProviders = async () => {
  const result = await axios.get(GET_ELECTRICITY_PROVIDERS());
  return result.data;
};

export const verifyMeterNumber = async (
  meterNumber,
  serviceId,
  serviceType
) => {
  const result = await axios.get(
    VERIFY_METER_NUMBER(meterNumber, serviceId, serviceType)
  );
  return result.data;
};

export const verifySmartCardNumber = async (serviceId, cardNumber) => {
  const result = axios.get(VERIFY_SMART_CARD_NUMBER(serviceId, cardNumber));
  return result.data;
};

export const buyPower = async (payload) => {
  const result = await axios.post(BUY_POWER(), payload);

  return result.data;
};

export const getPowerToken = async (txId) => {
  const result = await axios.get(GET_POWER_TOKEN(txId));

  return result.data;
};

export const getTvProviders = async () => {
  const result = await axios.get(GET_TV_PROVIDERS());
  return result.data;
};

export const getTvBouquets = async (providerId) => {
  const result = await axios.get(GET_TV_BOUQUETS(providerId));
  return result.data;
};

export const verifyTvSmartCard = async (serviceId, cardNumber) => {
  const result = await axios.get(VERIFY_TV_SMART_CARD(serviceId, cardNumber));
  return result.data;
};

export const payTvSubscription = async (payload) => {
  const result = await axios.post(PAY_TV_SUBSCRIPTION(), payload);
  return result.data;
};

export const getUtilitiesTransactionDetails = async (txid) => {
  const result = await axios.get(GET_UTILITIES_TRANSACTION(txid));
  return result.data;
};

export const getUtilityTransactions = async () => {
  const result = await axios.get(GET_UTILITY_TRANSACTIONS());
  return result.data;
};

export const getUtilityTransaction = async (id) => {
  const result = await axios.get(GET_UTILITY_TRANSACTION(id));
  return result.data;
};

export const getDownlinePurchases = async (wallet) => {
  const result = await axios.get(GET_DOWNLINE_PURCHASES(wallet));
  return result.data;
};

export const getReferrals = async () => {
  const result = await axios.get(GET_REFERRALS());
  return result.data;
};
